import { useEffect } from 'react';
import { createPortal } from 'react-dom';

const ImagePreviewer = ({ image, open, onClose }: { image: string, open?: boolean, onClose?: () => void }) => {
    useEffect(() => {
        if (open) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        // Cleanup on unmount
        return () => {
            document.body.style.overflow = '';
        }
    }, [open]);

    const isImage = image?.match(/\.(jpeg|jpg|png|gif|webp)$/i);

    // For non-image files, just open them directly in a new tab and close the previewer
    useEffect(() => {
        if (open && !isImage) {
            window.open(image, '_blank', 'noopener,noreferrer');
            onClose?.();
        }
    }, [open, isImage, image, onClose]);

    if (!isImage) return null;

    return open && createPortal(
        <div className="fixed inset-0 z-50 bg-black bg-opacity-90 flex items-center justify-center">

            {/* Close Button */}
            <button
                onClick={onClose}
                className="absolute top-5 right-5 text-white text-3xl"
            >
                ✕
            </button>

            {/* Preview */}
            <div className="w-full h-full flex items-center justify-center p-4">
                <img
                    src={image}
                    alt="Preview"
                    className="max-h-full max-w-full object-contain"
                />
            </div>
        </div>,
        document.body
    )
    
};

export default ImagePreviewer;